/**
 * Articles page specifics.
 */
 export default function articlesSection() {

  /** set top if needed */
  const setScrollTop = window.localStorage.getItem('articlesScrollTop');
  if (setScrollTop) {
    document.documentElement.scrollTop = document.body.scrollTop = setScrollTop;
    window.localStorage.removeItem('articlesScrollTop');
  }

  /** show more button */
  const showMoreButton = document.getElementById('showMoreButton');
  if (!showMoreButton) return;
  showMoreButton.addEventListener('click', event => {
    event.preventDefault();
    const href = showMoreButton.dataset.loadNext;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.localStorage.setItem('articlesScrollTop', scrollTop);
    document.location = href;
  });
}


// WEBPACK FOOTER //
// ./source/scripts/sections/articles.js